import { IBankModalContent, IBuilderModalContent, TOfferType } from './listing';

export enum EModalType {
  BANK = 'bank',
  BUILDER = 'builder',
}

interface ICommonInfoContent {
  offerName: string;
  offerDescription: string;
  iconPath: string;
}

export interface IBankInfoModalContent extends ICommonInfoContent, IBankModalContent {
  /** Банк выбранного оффера: доезжает до lead/create через query онбординга */
  bankId?: number | null;
}

export interface IBuilderInfoModalContent extends ICommonInfoContent, IBuilderModalContent {
  rate: number | string;
  monthlyPayment: number;
}

export type IModalContent = IBankInfoModalContent | IBuilderInfoModalContent;

export interface IModalState {
  isOpen: boolean;
  content: IModalContent | null;
  type: TOfferType | null;
}
